import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Divider,
  Grid,
  Hidden,
  IconButton,
  Menu,
  Toolbar,
  Typography,
  useTheme,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import fontConfig from "../../constants/fonts";
import MenuIcon from "@material-ui/icons/Menu";
import { toggleDrawer } from "../../redux/action/utilActions";
import { useHistory } from "react-router-dom";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";
import SearchBar from "../NavLinks/SearchBar";
import { getImageUrl } from "../../redux/types";

const logo = "/assets/images/logo/logo-light2.jpeg";

const breakpoint = (theme, style) => {
  return {
    [theme.breakpoints.down("md")]: {
      ...style,
    },
  };
};
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    ...breakpoint(theme, {
      marginTop: "1vh",
      marginBottom: "1vh",
    }),
  },
  logo: {
    height: 70,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      height: 50,
      marginBottom: theme.spacing(0),
    },
    // width: "20vh",
  },
  logoContainer: {},
  logoTitle: {
    ...fontConfig.medium,
    fontSize: 25,
    color: theme.palette.primary.dark,
  },
  headline: {
    ...fontConfig.medium,
    fontSize: "1.2rem",
  },
  otherLogo: {
    height: 50,
  },
  menuIcon: {
    fontSize: "2rem",
  },
}));

const NavBar = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useTheme().breakpoints.down("md");

  const handleNavigate = (link) => {
    window.open(link);
  };
  const gramId = useSelector((state) => state.util.currentGramId);

  const logo = "/images/logo/logo.png";
  return (
    <div className={classes.root}>
      <Toolbar className={classes.container}>
        <Grid
          container
          spacing={isMobile ? 0 : 2}
          alignItems={isMobile ? "center" : undefined}
        >
          <Grid
            item
            lg={1}
            md={1}
            sm={3}
            xs={3}
            className={classes.logoContainer}
            container
            alignItems="center"
          >
            <Grid item lg={12}>
              <img
                src={logo}
                className={classes.logo}
                onClick={(e) => {
                  history.push("/");
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            lg={7}
            md={7}
            sm={6}
            xs={6}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid item lg={12}>
              <MobileHidden>
                <Typography
                  variant="h6"
                  align="flex-start"
                  className={classes.headline}
                >
                  {data?.headline}
                </Typography>
              </MobileHidden>

              <DesktopHidden>
                <Typography
                  variant="h6"
                  align="flex-start"
                  className={classes.headline}
                >
                  {data?.title}
                </Typography>
              </DesktopHidden>
            </Grid>
          </Grid>

          <DesktopHidden>
            <Grid item lg={3} sm={3} md={3} xs={3} container justify="flex-end">
              <IconButton
                onClick={() => {
                  dispatch(toggleDrawer());
                }}
              >
                <MenuIcon className={classes.menuIcon} />
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              <SearchBar data={data?.searchInputLabel} />
            </Grid>
          </DesktopHidden>
          <MobileHidden>
            <Grid
              item
              lg={4}
              container
              className={classes.otherLogosContainer}
              alignItems="center"
              justify="space-between"
            >
              {data?.otherLogos?.map((logo, index) => {
                return (
                  <Grid
                    item
                    key={index}
                    // onClick={() => handleNavigate(logo.link)}
                  >
                    <img src={logo.src} className={classes.otherLogo} />
                  </Grid>
                );
              })}
            </Grid>
          </MobileHidden>
        </Grid>
      </Toolbar>
      <Divider />
    </div>
  );
};
export default NavBar;
